import React from 'react'
import Inputs from '../../components/Inputs'
export default () => (
  <Inputs />
)